import { Expose } from "class-transformer";

export class AssignPlanningBoardTrainingDto {
  @Expose()
  userId: string;
}
